<script>
  export default {
    name: 'form-render',
    inject: ['formData', 'store'],
    props: {
      node: {
        type: Object
      }
    },
    render (h) {
      const {viewContent, props} = this.node
      return (
        <sy-form
          ref='form'
          props={{
            model: this.formData,
            ...props
          }}
          attrs={{size: 'small'}}
        >
          <render viewContent={viewContent}/>
        </sy-form>
      )
    },
    mounted () {
      this.store.saveRef('form', this.$refs.form)
    }
  }
</script>
